<template>
  <v-main>
    <v-fade-transition hide-on-leave="">
      <router-view :key="$route.path" />
    </v-fade-transition>
  </v-main>
</template>

<script>
export default {
  name: 'DefaultView'
}
</script>

<style lang="scss">
  .v-main {
    .v-main__wrap {
      padding-top: 30px;
      h2 {
        margin-bottom: 15px;;
      }
    }
  }
</style>
